"use client";

import { formatDurationSeconds, parseDurationSeconds } from "@repo/domain";
import { useState } from "react";
import { InputField } from "./input-field";
import type { NumberFieldProps } from "./number-field";

export function DurationSecondsField({ value, onChange, onBlur, min, max, errors, ...props }: NumberFieldProps) {
  const [draft, setDraft] = useState<string | null>(null);
  const [invalid, setInvalid] = useState(false);
  return (
    <InputField
      label={props.label}
      ariaLabel={props.ariaLabel}
      description={props.description}
      disabled={props.disabled}
      isRequired={props.isRequired}
      placeholder="mm:ss"
      value={draft ?? (value === null ? "" : formatDurationSeconds(value))}
      errors={invalid ? ["Enter seconds or mm:ss within the allowed range"] : errors}
      isTouched={invalid || props.isTouched}
      onChange={(text) => {
        setDraft(text);
        const parsed = parseDurationSeconds(text);
        const valid =
          parsed !== undefined && (min === undefined || parsed >= min) && (max === undefined || parsed <= max);
        setInvalid(text !== "" && !valid);
      }}
      onBlur={() => {
        if (draft !== null) {
          const parsed = parseDurationSeconds(draft);
          if (draft.trim() === "") onChange(null);
          else if (parsed !== undefined && (min === undefined || parsed >= min) && (max === undefined || parsed <= max))
            onChange(parsed);
        }
        setDraft(null);
        setInvalid(false);
        onBlur();
      }}
    />
  );
}
